import React from "react";
import { Phone, Mail, Globe, MapPin, MessageCircle } from "lucide-react";
import { useLang } from "../lib/i18n";

const PHONE = "6984141945";
const EMAIL = "info@ellinikosthisavros.gr";
const WEBSITE = "www.ellinikosthisavros.gr";
const LOCATION = "Παράδεισος Center, Σόφια, Βουλγαρία";

export const Contact = () => {
  const { t } = useLang();
  const whatsappUrl = `https://wa.me/30${PHONE}?text=${encodeURIComponent(t("contact.whatsappMsg"))}`;

  const items = [
    { icon: Phone, label: PHONE, href: `tel:+30${PHONE}`, testid: "contact-phone" },
    { icon: Mail, label: EMAIL, href: `mailto:${EMAIL}`, testid: "contact-email" },
    { icon: Globe, label: WEBSITE, href: `https://${WEBSITE}`, testid: "contact-web" },
    { icon: MapPin, label: LOCATION, href: null, testid: "contact-loc" },
  ];

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 sm:py-32 px-6 bg-goldenelia grain"
    >
      <div className="max-w-4xl mx-auto text-center">
        <p className="font-display text-xs tracking-[0.5em] text-gold uppercase mb-4">
          {t("contact.eyebrow")}
        </p>
        <h2 className="font-serif-luxury text-4xl sm:text-5xl gold-gradient-text mb-6">
          {t("contact.title")}
        </h2>
        <div className="gold-divider max-w-md mx-auto mb-10">
          <span className="diamond" />
        </div>
        <p className="font-serif-luxury italic text-lg text-[color:var(--goldenelia-cream)]/85 mb-12 max-w-2xl mx-auto">
          {t("contact.sub")}
        </p>

        <div className="grid sm:grid-cols-2 gap-5 mb-10 text-left">
          {items.map(({ icon: Icon, label, href, testid }) => {
            const Tag = href ? "a" : "div";
            return (
              <Tag
                key={label}
                data-testid={testid}
                href={href || undefined}
                target={href && href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                className="group flex items-center gap-4 p-5 border border-[color:var(--goldenelia-gold)]/25 bg-goldenelia-card hover:border-[color:var(--goldenelia-gold)]/55 transition-colors"
              >
                <span className="w-11 h-11 flex items-center justify-center border border-[color:var(--goldenelia-gold)]/40 text-[color:var(--goldenelia-gold)] group-hover:bg-[color:var(--goldenelia-gold)] group-hover:text-black transition-colors">
                  <Icon size={18} />
                </span>
                <span className="font-body text-sm text-[color:var(--goldenelia-cream)]/85 break-all">
                  {label}
                </span>
              </Tag>
            );
          })}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            data-testid="whatsapp-btn"
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="btn-ghost-gold"
          >
            <MessageCircle size={18} /> {t("contact.whatsapp")}
          </a>
          <a
            data-testid="call-btn"
            href={`tel:+30${PHONE}`}
            className="btn-ghost-gold"
          >
            <Phone size={16} /> {t("contact.call")}
          </a>
        </div>

        <p className="mt-12 font-serif-luxury italic text-sm text-[color:var(--goldenelia-gold)]/85">
          {t("contact.owner")}
        </p>
      </div>
    </section>
  );
};

export default Contact;
